import { cn } from "../../lib/utils.js";

const spinClass = "animate-[spin_0.8s_linear_infinite] motion-reduce:animate-none";

export function WorkspaceLoader({
  message,
  layout = "panel",
  testId,
}: {
  message: string;
  layout?: "panel" | "inline";
  testId?: string;
}): React.JSX.Element {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      data-testid={testId}
      className={cn(
        "flex items-center justify-center gap-2.5 text-[0.8125rem] text-muted",
        layout === "panel" && "px-6 py-10",
        layout === "inline" && "px-1 py-1",
      )}
    >
      <span
        className={cn(
          "size-4 shrink-0 rounded-full border-2 border-line border-t-accent",
          spinClass,
        )}
        aria-hidden="true"
      />
      <span>{message}</span>
    </div>
  );
}

export function ListSkeleton({
  rows = 4,
  label,
  testId,
}: {
  rows?: number;
  label: string;
  testId?: string;
}): React.JSX.Element {
  return (
    <div role="status" aria-live="polite" aria-busy="true" data-testid={testId} className="grid gap-2 p-3">
      <span className="sr-only">{label}</span>
      {Array.from({ length: rows }, (_, index) => (
        <div
          key={index}
          className="h-14 animate-pulse rounded-lg border border-line bg-surface motion-reduce:animate-none"
        />
      ))}
    </div>
  );
}

export function CardSkeleton({
  label,
  testId,
}: {
  label: string;
  testId?: string;
}): React.JSX.Element {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      data-testid={testId}
      className="grid gap-3 rounded-xl border border-line bg-surface p-5"
    >
      <span className="sr-only">{label}</span>
      <div className="h-4 w-32 animate-pulse rounded bg-surface-muted motion-reduce:animate-none" />
      <div className="h-3 w-full max-w-sm animate-pulse rounded bg-surface-muted motion-reduce:animate-none" />
      <div className="h-9 w-36 animate-pulse rounded-md bg-surface-muted motion-reduce:animate-none" />
    </div>
  );
}
